import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import { LinkToAddOnMarketplace } from './link-to-add-on-marketplace';
import messages from '../messages';
import style from './style.module.less';

export const SeeMoreTile = () => {
  return (
    <div className={style['addon-card']}>
      <div className={style['see-more-tile-text']}>
        <Text element='h1' textType={TextType.H3} value={messages.seeMore} />
        <LinkToAddOnMarketplace />
      </div>
    </div>
  );
};
